<div class="page-container gap-24">
  <app-title-card id="title-card" [titleCard]="titleCard"></app-title-card>
  <span class="align-self-stretch subtitle">
    Willkommen im InWi – Dein Institut für einfach gutes Wissen
  </span>
  <span class="align-self-stretch font-regular-body-large">
    Du möchtest Dich beruflich weiterentwickeln und dabei auf aktuelles,
    evidenzbasiertes Wissen setzen? Willkommen bei InWi – Deinem Partner für
    hochwertige Fortbildungen, die Dich nachhaltig weiterbringen.
  </span>
  <span class="align-self-stretch subtitle">
    Warum Fortbildungen bei InWi?
  </span>
  <span class="align-self-stretch">
    <ul>
      <li>
        <span class="font-bold-body-large"> Evidenzbasiertes Wissen: </span>
        <span class="font-regular-body-large">
          Unsere Inhalte werden gemeinsam mit erfahrenen Dozierenden entwickelt
          und regelmäßig auf den neuesten Stand der Wissenschaft gebracht. So
          garantieren wir Dir höchste Qualität und Aktualität.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Praxistauglich: </span>
        <span class="font-regular-body-large">
          Alle unsere Kurse sind darauf ausgelegt, dass Du das Erlernte sofort
          in Deinem beruflichen Alltag umsetzen kannst.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Wissen jederzeit verfügbar: </span>
        <span class="font-regular-body-large">
          Mit unserem umfangreichen digitalen Archiv hast Du auch nach der
          Fortbildung Zugriff auf Artikel, Studien und weitere Materialien, die
          Dich unterstützen.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Attraktive Konditionen: </span>
        <span class="font-regular-body-large">
          Unsere Fortbildungen bieten ein ausgezeichnetes
          Preis-Leistungs-Verhältnis, da wir eng mit Sponsoren und
          Kooperationspartnern zusammenarbeiten, um Dir hochwertige Angebote zu
          ermöglichen.
        </span>
      </li>
    </ul>
  </span>
  <span class="align-self-stretch subtitle"> Unsere Angebote: </span>
  <span class="align-self-stretch">
    <ul>
      <li>
        <span class="font-bold-body-large"> Topaktuelle Inhalte: </span>
        <span class="font-regular-body-large">
          Immer auf dem neuesten wissenschaftlichen Stand.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Expertise aus erster Hand: </span>
        <span class="font-regular-body-large">
          Lerne von anerkannten Experten und Spezialisten.
        </span>
      </li>
      <li>
        <span class="font-bold-body-large"> Anwendbare Inhalte: </span>
        <span class="font-regular-body-large">
          Praktische Tipps und Werkzeuge, die direkt in den Alltag integriert
          werden können.
        </span>
      </li>
    </ul>
  </span>
  <span class="align-self-stretch font-regular-body-large">
    Melde dich jetzt an und investiere in deine berufliche Zukunft – mit
    Fortbildungen, die sowohl inhaltlich als auch preislich überzeugen!
  </span>
</div>
